import script from "./printList.vue?vue&type=script&setup=true&lang=ts"
export * from "./printList.vue?vue&type=script&setup=true&lang=ts"

import "./printList.vue?vue&type=style&index=0&id=5c7019d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c7019d4"]])

export default __exports__